import { baseURL as baseUrl, setTokenHeader } from '@config/axiosConfig';
import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

export const configuredFetchBaseQuery = (paramsSerializer = null) => {
  const props = {
    baseUrl,
    prepareHeaders: setTokenHeader,
    credentials: 'include',
  };
  if (paramsSerializer) {
    props.paramsSerializer = paramsSerializer;
  }
  const rawBaseQuery = fetchBaseQuery({ ...props });
  return async (args, api, extraOptions) => {
    api.extra = extraOptions;
    return rawBaseQuery(args, api, extraOptions);
  };
};
